//
//
//
//
//
//

export default {
  name: "showRefresh-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};